import gql from 'graphql-tag';

const MUTATION_RESET_PASSWORD = gql`
  mutation resetPassword($userId: ID!) {
    resetPassword(userId: $userId) {
      isSuccess
      message
    }
  }
`;

export default MUTATION_RESET_PASSWORD;
